import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Constants from '../../config/constants';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';
import DataTable from '../../components/datatable/DataTable';
import ZoneCreateModal from '../../modal/zone/ZoneCreateModal';
import ZoneEditModal from '../../modal/zone/ZoneEditModal';
import ZoneDuplicateModal from '../../modal/duplicate/ZoneDuplicateModal';
import Alert from '../../modal/alert/Alert';
import SearchBar from '../datatable/SearchBar';

import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';

import {
  clearErrorZone,
  deleteZone,
  listZone,
} from '../../redux/zone/zone_actions';

class ZoneDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coefficientColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const { t } = props;

    this.columns = [
      {
        id: 'name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id }),
        Cell: row => <Link to={`/zones/${row.value.id}`}>{row.value.name}</Link>,
        ...textColumn,
      },
      {
        Header: () => <b>{`${t('area')} (${t('sq m')})`}</b>,
        accessor: 'area',
        ...coefficientColumn,
      },
      {
        Header: () => <b>{t('floors')}</b>,
        accessor: 'floor_name',
        ...textColumn,
      },
      {
        Header: () => <b>{t('description')}</b>,
        accessor: 'description',
        ...textColumn,
      },
    ];

    this.state = {
      categoryOption: 'all',
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listZone(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isDuplicating,
      isLoading,
      isDeleting,
      errorMessage,
      building,
      t,
    } = this.props;

    return (
      <div>
        <ZoneCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
          building={building}
        />
        <ZoneEditModal
          zone={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
          building={building}
        />
        <ZoneDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy zone')}
          label={t('new zone name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete zone')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? `${t('deleting')}...` : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteZone(item.id)}
        />
        <SearchBar
          onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)}
          auxiliaryButton={<Button bsStyle="success" onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}>{t('create')}</Button>}
        />
        <DataTable
          columns={this.columns}
          data={this.props.zones}
          onActionEdit={item => this.setState({isShowEditModal: true, selectedInstance: item.original, isEdited: false})}
          onActionDuplicate={item => this.setState({isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false})}
          onActionDelete={item => this.setState({isShowDeleteModal: true, selectedInstance: item.original})}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  zones: state.zone.orderedIds.map(id => state.zone.objects[id]),
  filteredCount: state.zone.filteredCount,
  errorMessage: state.zone.errorMessage,
  isLoading: state.zone.isLoading,
  isCreating: state.zone.isCreating,
  isEditing: state.zone.isEditing,
  isDeleting: state.zone.isDeleting,
  isDuplicating: state.zone.isDuplicating,
});

const mapDispatchToProps = (dispatch, props) => ({
  listZone: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listZone(pageSize, page, sorted, filtered, isPublic, props.building.id)),
    ),
  deleteZone: id => defaultRejectHandler(dispatch(deleteZone(id))),
  clearError: () => dispatch(clearErrorZone()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ZoneDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/ZoneDataTable.js